import { Link } from "react-router-dom";
import { Shield, ShieldCheck, RefreshCw, Target, Crosshair, Award, ArrowUpRight, CalendarDays, Users } from "lucide-react";
import { fmtDate, EVENT_TYPES, icsDownload } from "../lib/api";
import { Badge } from "./Common";

const ICONS = { shield: Shield, "shield-check": ShieldCheck, refresh: RefreshCw, target: Target, crosshair: Crosshair, award: Award };

export const CourseCard = ({ c, i = 0, big = false }) => {
  const Icon = ICONS[c.icon] || Shield;
  return (
    <Link to={`/egitimlerimiz/${c.slug}`} data-testid={`course-card-${c.slug}`}
      className={`card-ada group p-6 flex flex-col justify-between min-h-[200px] fade-up ${big ? "bg-zinc-950 text-white border-zinc-950 hover:border-[#dc2626]" : ""}`} style={{ animationDelay: `${i * 60}ms` }}>
      <div className="flex justify-between items-start">
        <span className={`w-12 h-12 flex items-center justify-center ${big ? "bg-[#dc2626]" : "bg-red-50 text-[#dc2626]"}`}><Icon size={22} /></span>
        <ArrowUpRight className="text-zinc-400 group-hover:text-[#dc2626]" style={{ transition: "color .2s" }} />
      </div>
      <div className="mt-6">
        <h3 className="text-lg font-black leading-snug">{c.title}</h3>
        <p className={`mt-2 text-sm line-clamp-2 ${big ? "text-zinc-400" : "text-zinc-600"}`}>{c.summary}</p>
      </div>
    </Link>
  );
};

export const EventRow = ({ e }) => (
  <div className="card-ada p-5 grid gap-4 md:grid-cols-[120px_1fr_auto] md:items-center" data-testid={`event-row-${e.id}`}>
    <div className="flex md:flex-col gap-2 md:gap-0 items-baseline">
      <span className="font-display text-3xl font-black text-[#dc2626]">{e.start_date?.slice(8, 10)}</span>
      <span className="text-xs font-bold uppercase text-zinc-500">{new Date(e.start_date + "T00:00:00").toLocaleDateString("tr-TR", { month: "long", year: "numeric" })}</span>
    </div>
    <div>
      <div className="flex flex-wrap gap-2 mb-1.5">
        <Badge tone="dark">{EVENT_TYPES[e.type] || e.type}</Badge>
        {e.is_open ? <Badge tone="green" testid="event-open-badge">Başvuruya açık</Badge> : <Badge tone="zinc" testid="event-closed-badge">Başvuruya kapalı</Badge>}
        {!e.date_confirmed && <Badge tone="amber">Tarih kesinleşmedi</Badge>}
      </div>
      <h3 className="font-bold">{e.title}</h3>
      <p className="text-xs text-zinc-500 mt-1 flex flex-wrap gap-x-4 gap-y-1">
        <span className="inline-flex items-center gap-1"><CalendarDays size={12} />{fmtDate(e.start_date)}{e.end_date && e.end_date !== e.start_date ? ` – ${fmtDate(e.end_date)}` : ""}{e.time ? ` • ${e.time}` : ""}</span>
        {!!e.capacity && <span className="inline-flex items-center gap-1"><Users size={12} />Kontenjan: {e.capacity} {e.enrolled ? `(kayıtlı ${e.enrolled})` : ""}</span>}
        {e.application_deadline && <span>Son başvuru: {fmtDate(e.application_deadline)}</span>}
      </p>
      {e.description && <p className="text-sm text-zinc-600 mt-2">{e.description}</p>}
    </div>
    <div className="flex gap-2">
      <button className="btn-outline !px-3 !py-2 text-zinc-900 hover:!bg-zinc-950 hover:!text-white text-xs" onClick={() => icsDownload(e)} data-testid={`event-ics-${e.id}`}>Takvime Ekle</button>
      {e.is_open && <Link to={`/kurs-basvurusu?donem=${e.id}`} className="btn-red !px-3 !py-2 text-xs" data-testid={`event-apply-${e.id}`}>Başvur</Link>}
    </div>
  </div>
);
